// Layout settings (text size, column widths, bar heights) as custom
// properties on the root element. Not part of the theme; the stylesheets
// read them with their own fallbacks.

export const LAYOUT_KEYS = [
  'sidebarColumnWidth',
  'contentColumnWidth',
  'notifsColumnWidth',
  'navbarSize',
  'panelHeaderSize',
  'textSize',
]

export const layoutVariables = (config) =>
  Object.fromEntries(
    LAYOUT_KEYS.filter((key) => config[key]).map((key) => [
      `--${key}`,
      config[key],
    ]),
  )

export const applyLayoutVariables = (
  config,
  root = document.documentElement,
) => {
  const variables = layoutVariables(config)
  LAYOUT_KEYS.forEach((key) => {
    const name = `--${key}`
    if (variables[name]) {
      root.style.setProperty(name, variables[name])
    } else {
      root.style.removeProperty(name)
    }
  })
}
